module.exports = __webpack_public_path__ + "190c047fb4f3e0cf82c24ce9543680e3.svg";